import React from 'react';
export default function SquareCrewCut({
  light,
  dark,
}) {
  return (
    <><path d="M10.354 3.98H23.64c2.551 0 4.636 2.053 4.605 4.604l-.03 2.376c-.03 2.55-1.877-3.384-5.748-3.373l-10.94.03c-3.68.01-5.84 5.894-5.808 3.343l.03-2.376c.031-2.55 2.053-4.605 4.605-4.605z" fill={light} /><path d="M22.942 7.094c2.552 0 5.303 3.607 5.303 3.607l-.03.259c-.094 2.55-1.877-3.384-5.748-3.373l-10.94.03c-3.68.01-5.902 5.892-5.808 3.343l.03-.26S8.56 7.104 11.11 7.095c3.852-.013 7.501 0 11.831 0z" fill={dark} /></>
  );
}
